import Web3Modal from "web3modal";
import {ethers} from "ethers";
import Market from "../../../contracts/NFTMarket.json";

export async function listForSale(nftaddress: string, priceI: string, nftmarketaddress:string, tokenid: string) {
    const web3Modal = new Web3Modal()
    const connection = await web3Modal.connect()
    const provider = new ethers.providers.Web3Provider(connection)
    const signer = provider.getSigner()

    const price = ethers.utils.parseUnits(priceI, 'ether')

    /* then list the item for sale on the marketplace */
    let contract = new ethers.Contract(nftmarketaddress, Market.abi, signer)
    let listingPrice = await contract.getListingPrice()

    console.log(listingPrice);
    listingPrice = listingPrice.toString()
    let transaction;

    transaction = await contract.createMarketItem(nftaddress, tokenid, price, {value: listingPrice})


    return await transaction.wait()
}
